import { useEffect, useRef } from "react";
import { Animated, Easing, StyleSheet, Text, View } from "react-native";
import Svg, { Circle, Defs, LinearGradient, Stop } from "react-native-svg";
import { useCustomTheme } from "../hooks/useCustomTheme";
const AnimatedSvg = Animated.createAnimatedComponent(Svg);
export const ThemedLoader = ({ text, spinnerSize = 104, children, info, }) => {
    const { colors } = useCustomTheme();
    const rotateAnim = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        const startRotation = () => {
            rotateAnim.setValue(0);
            Animated.loop(Animated.timing(rotateAnim, {
                toValue: 1,
                duration: 1500,
                easing: Easing.linear,
                useNativeDriver: true,
            }), { iterations: -1 }).start();
        };
        startRotation();
        return () => {
            rotateAnim.stopAnimation();
        };
    }, [rotateAnim]);
    const rotate = rotateAnim.interpolate({
        inputRange: [0, 1],
        outputRange: ["0deg", "360deg"],
    });
    const strokeWidth = 7;
    const radius = (spinnerSize - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const strokeDasharray = circumference * 0.8; // use 80% of the full circle as display area
    const center = spinnerSize / 2;
    return (<View style={styles.container}>
      {info}
      <View style={styles.iconContainer}>
        {children}
        <Svg width={spinnerSize} height={spinnerSize} style={styles.backgroundCircle}>
          <Circle cx={center} cy={center} r={radius} stroke={`${String(colors.border)}20`} strokeWidth={strokeWidth} fill="none" testID="background-circle"/>
        </Svg>
        <AnimatedSvg width={spinnerSize} height={spinnerSize} style={[
            styles.spinner,
            {
                transform: [{ rotate }],
            },
        ]} testID="spinner-svg">
          <Defs>
            <LinearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <Stop offset="0%" stopColor={colors.border} stopOpacity="1"/>
              <Stop offset="60%" stopColor={colors.border} stopOpacity="0.8"/>
              <Stop offset="100%" stopColor={colors.border} stopOpacity="0"/>
            </LinearGradient>
          </Defs>
          <Circle cx={center} cy={center} r={radius} stroke="url(#spinnerGradient)" strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={`${strokeDasharray} ${circumference}`} strokeDashoffset={0} fill="none" transform={`rotate(-90 ${center} ${center})`} testID="spinner-circle"/>
        </AnimatedSvg>
        {text && (<Text style={[styles.loadingText, { color: colors.border }]}>
            {text}
          </Text>)}
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    iconContainer: {
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
    },
    backgroundCircle: {
        position: "absolute",
    },
    spinner: {
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
    },
    loadingText: {
        position: "absolute",
        top: 110,
        fontSize: 24,
        fontWeight: "bold",
    },
});
//# sourceMappingURL=ThemedLoader.js.map